
export default {
  name: `MyCheckCreditReformResult`,
  props: {
    myCheck: {
      type: Object,
      default: undefined
    }
  },
  computed: {
    checksDocs() {
      return this.myCheck?.result_documents
    }
  }
}
